<template lang="html">
  <div class="e2e-home page-submenu">
      <div class="e2e-container" style="display: flex;justify-content:space-between;">
          <div class="page-submenu_left">
            <div class="e2e-content-box">
                <left-bar tab='user-authorizelm'></left-bar>
            </div>
          </div>
          <div class="page-submenu_right">
            <div class="e2e-content-box">
                <div class='user-container'>
                    <div class="user-basic-container">
                        <div class="authorizelm-text">授权功能说明： 针对指定对象进行审批权限的授权，本人失去原有审批权限，可以在授权页面查看和维护授权功能，无法针对多个用户进行重复授权。</div>
                        <div class="search-content">
                            <div class="search-content-fields">
                                <el-button type="primary" @click="handleAddNewClick()" >添加</el-button>
                            </div>
                        </div>
                    <el-table
                    :data="tableData"
                    style="width: 100%"
                    header-cell-class-name="table-header-cell" 
                    tooltip-effect="light">
                    <el-table-column v-if="isAdmin" prop="licensorAd" label="授权人AD">
                    </el-table-column>
                    <el-table-column v-if="isAdmin" prop="licensorName" label="授权人姓名">
                    </el-table-column>
                    <el-table-column  prop="authorizedPersonAd" label="被授权人AD">
                    </el-table-column>
                    <el-table-column   prop="authorizedPersonName" label="被授权人姓名" >
                    </el-table-column>
                    <el-table-column  prop="authorizedPersonEmail" label="被授权人邮箱">
                    </el-table-column>
                    <el-table-column  prop="authorizationDeadline" label="授权截至日期">
                    </el-table-column>
                    <el-table-column fixed="right" label="终止授权">
                        <template slot-scope="scope">
                        <el-button type="text" @click="handleDeleteClick(scope.row)">
                            终止
                        </el-button>
                    </template>
                    </el-table-column>
                    </el-table>
                       
                    </div>                    
                </div>
    <!-- 确认删除 -->
    <common-confirm :dialogVisiable.sync="confirmDeleteVisible" :confirm="handlerDeleteConfirmOK">
        <div>
          是否确认取消授权?
        </div>
    </common-confirm>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import api from "@/api/user/authorize";
import LeftBar from "../LeftBar";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LeftBar,
  },
  data() {
    return {
      tableData: [],
      isAdmin: false,
      confirmDeleteVisible: false,
      rowId: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    ...mapActions(["initBaseDataByTypes"]),
    getList() {
      api.list({ authorizationType: "1" }).then((res) => {
        if (Array.isArray(res)) {
          this.tableData = res;
        }
      });
    },
    handleAddNewClick() {
      this.$router.push({
        name: "user-authorizelm-add",
      });
    },
    handleDeleteClick(data) {
      this.confirmDeleteVisible = true;
      this.rowId = data.id;
    },
    handlerDeleteConfirmOK() {
      api.stop({ id: this.rowId }).then((res) => {
        if (res) {
          this.getList();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败",
          });
        }
      });
    },
  },
  mounted() {
    for (let index = 0; index < this.userInfo.roleCodes.length; index++) {
      const element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.el-message-box__wrapper {
  margin: 20px;
}
.el-message-box {
  margin: 20px;
  .el-button--primary {
    background-color: #0b41cd;
    color: #fff;
    border-color: #0b41cd;
  }
}

.user-container {
  padding: 48px 80px 56px;
  display: flex;

  .user-basic-container {
    width: 100%;
  }
  .authorizelm-text {
    margin-bottom: 22px;
  }
  .search-content {
    margin-bottom: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0438ef38